import { doc, updateDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import AI from "../../models/AI";

async function updateAI(ai: AI): Promise<void> {
  try {
    const aiPatch = ai.toFirestorePatch();
    const db = firestore;
    await updateDoc(doc(db, FirestoreCollections.ai, ai.id), aiPatch);
    return;
  } catch (e) {
    console.log("error: ", e);
    throw new UpdateAIFailure();
  }
}

export class UpdateAIFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updateAI;
